export default __webpack_public_path__ + "static/media/gastro_4.cd7d2a10.jpg";